import { axiosInstance } from './axiosInstance';

export const getTeamMaxScore = () =>
    axiosInstance({
        method: 'GET',
        url: `team/get_team_max_score`,
    });
